module.exports = "/_next/static/images/statistics-2x-ee992dbd45a095c91f6be9e6fad08923.png";